import React from 'react';
import PropTypes from 'prop-types';
import PendingApprovalDTO from '../../../DTOs/Subscription/PendingApprovalDTO';
import DetailPanel from './DetailPanel';
import { USDollar } from '../../../utilities/Constants';
import { formatPhoneNumber } from '../../../utilities/PhoneFormat';

export default function PendingApprovalsUserDetailPanel(props) {
    const { row } = props;

    return (
        <DetailPanel
            sections={[
                {
                    title: 'Requested by',
                    fields: [
                        { label: 'Name', value: `${row.appUser.firstName} ${row.appUser.lastName}` },
                        { label: 'Email', value: row.appUser.username },
                        { label: 'Phone', value: formatPhoneNumber(row.appUser.phone) },
                        { label: 'Licence', value: row.appUser.driversLicenseNumber },
                    ],
                },
                {
                    title: 'Storage unit',
                    fields: [
                        { label: 'Unit', value: row.storageUnit.name },
                        { label: 'Size', value: row.storageUnit.storageSize },
                        { label: 'Price', value: USDollar.format(row.storageUnit.price) },
                    ],
                },
            ]}
        />
    );
}

PendingApprovalsUserDetailPanel.propTypes = {
    row: PropTypes.objectOf(PendingApprovalDTO),
};
